import React from 'react';

const WhiteCard = ({ children, style = {} }) => {
  return (
    <div style={{
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
      padding: '20px',
      width: '100%',
      boxSizing: 'border-box',
      ...style
    }}>
      {children}
    </div>
  );
};

export default WhiteCard;